import { useState, FC, useEffect } from 'react';
import { useListenMessage } from '@src/application/hooks/useListenMessage';
import {
  MSG_NAME_FROM_IFRAME,
  MSG_NAME_TO_IFRAME,
  sendMessageFromIframe,
} from '@src/container/handleIframeMessage/handleIframeMessage';
import { formatEvent } from '../../Events/helpers';
import { EventType } from '../../Events/types';
import { useTagData } from '../../shared/tag/context/useTagData';

import styles from '@application/modules/shared/components/Header/EventNotification/EventNotification.module.scss';

export const AB_TASTY_QA_ASSISTANT_NOTIFICATION = 'AB_TASTY_QA_ASSISTANT_NOTIFICATION' as const;
export const EVENT_NOTIFICATION_TEST_ID = 'event-notification' as const;

export const EventNotification: FC<{ activeTab: boolean }> = ({ activeTab }) => {
  const [isCollapsed, setIsCollapsed] = useState<boolean>(true);
  const [events, setEvents] = useState<number>(0);
  const { accountData } = useTagData();

  const setNotifications = () => {
    try {
      const notifications = sessionStorage.getItem(AB_TASTY_QA_ASSISTANT_NOTIFICATION);
      if (notifications) {
        setEvents(() => {
          sendMessageFromIframe({ name: MSG_NAME_FROM_IFRAME.QaAssistantEventNotification, value: +notifications });
          return +notifications;
        });
      }
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
      setEvents(() => {
        sessionStorage.setItem(AB_TASTY_QA_ASSISTANT_NOTIFICATION, '0');
        return 0;
      });
    }
  };

  useListenMessage(
    ({ data }) => {
      if (
        data.name === MSG_NAME_TO_IFRAME.ABTastyEvent &&
        data.type === EventType.EVENT &&
        (!activeTab || isCollapsed)
      ) {
        const formatedEvent = formatEvent(data, accountData.tests);
        if (!formatedEvent) return;

        setEvents((value) => {
          const eventValue = value + 1;
          sessionStorage.setItem(AB_TASTY_QA_ASSISTANT_NOTIFICATION, eventValue.toString());
          sendMessageFromIframe({ name: MSG_NAME_FROM_IFRAME.QaAssistantEventNotification, value: eventValue });
          return eventValue;
        });
      }
      if (data.name === MSG_NAME_TO_IFRAME.QaAssistantCollapse && typeof data.value === 'boolean') {
        setIsCollapsed(() => data.value);
        if (!data.value && activeTab) {
          setEvents(() => {
            sendMessageFromIframe({ name: MSG_NAME_FROM_IFRAME.QaAssistantEventNotification, value: 0 });
            sessionStorage.setItem(AB_TASTY_QA_ASSISTANT_NOTIFICATION, '0');
            return 0;
          });
        }
      }
    },
    [activeTab, isCollapsed]
  );

  useEffect(() => {
    if (activeTab) {
      setEvents(() => {
        sendMessageFromIframe({ name: MSG_NAME_FROM_IFRAME.QaAssistantEventNotification, value: 0 });
        sessionStorage.setItem(AB_TASTY_QA_ASSISTANT_NOTIFICATION, '0');
        return 0;
      });
    }
  }, [activeTab]);

  useEffect(() => setNotifications(), []);

  return events ? (
    <div data-testid={EVENT_NOTIFICATION_TEST_ID} className={styles.notification}>
      {events > 9 ? '9+' : events}
    </div>
  ) : null;
};
